import { forwardRef, useRef, type InputHTMLAttributes, type ReactNode } from 'react'

import { useForceFocusOnElement } from '@/legacy/hooks/useForceFocusOnElement'

import { RadioButtonStyles, Divider } from './styles'

interface Props extends Partial<InputHTMLAttributes<HTMLInputElement>> {
  label?: string | ReactNode
  children?: ReactNode
  className?: string
  forceFocus?: boolean
}

const RadioButton = forwardRef<HTMLInputElement, Props>(
  ({ label, forceFocus = true, children, className, checked, ...props }: Props, ref) => {
    const labelRef = useRef<HTMLLabelElement>(null)
    useForceFocusOnElement(labelRef, forceFocus)

    return (
      <>
        <RadioButtonStyles ref={checked ? labelRef : null} className={className}>
          <input type="radio" {...props} ref={ref} className="radio-button__input" />
          <span />
          <span aria-hidden> {children || label}</span>
        </RadioButtonStyles>
        <Divider />
      </>
    )
  },
)

RadioButton.displayName = 'RadioButton'

export default RadioButton
